import * as angular from 'angular';
import * as _ from 'lodash';
import { Group } from '../../models/entities';
import { ComponentDefinition, Pattern } from '../../models';

class GroupSelectorController implements angular.IComponentController {
    isLoading: boolean;
    loadingMessage: string;
    selectedItem: Group;
    groups: Group[];
    model: string;
    formController: angular.IFormController;
    name: string;
    isPopoverOpen: boolean;
    onChange?: ({ viewValue: string }) => void;
    searchCriteria: Pattern<Group>[];

    static $inject = ['$scope'];
    constructor(private _$scope: angular.IScope) {
    }

    $onInit() {
        this.searchCriteria = [
            {
                placeholder: 'Search pattern on group',
                label: 'Group',
                model: 'g',
                property: 'g',
                isMatch: (group, reg) => {
                    return reg.test(group.uniqueName);
                }
            },
            {
                placeholder: 'Search pattern on group type',
                label: 'Group types',
                model: 'gt',
                property: 'gt',
                isMatch: (group, reg) => {
                    return reg.test(group.type);
                }
            }, {
                placeholder: 'Search pattern on comment',
                label: 'Comment',
                model: 'c',
                property: 'c',
                isMatch: (group, reg) => {
                    return reg.test(group.shortComment) || reg.test(group.longComment);
                }
            }
        ];
        this.selectItem();
        this._$scope.$watch(() => this.selectedItem, (newValue: Group) => {
            if (newValue) {
                if (this.formController && this.name && newValue.guid !== this.model) {
                    this.model = newValue.guid;
                    this.formController[this.name].$viewValue = this.model;
                    this.formController[this.name].$setDirty();
                    this.formController[this.name].$setValidity('required', true);
                }
            }
        });
        this._$scope.$watch(() => this.model, () => {
            this.selectItem();
        });
    }

    private selectItem() {
        if (this.model && this.groups && this.groups.length) {
            this.selectedItem = _.find(this.groups, g => g.guid === this.model);
        } else {
            this.selectedItem = null;
        }
        this.isPopoverOpen = false;
        if (this.onChange) {
            this.onChange({ viewValue: this.model });
        }
    }

    $onChanges(changes: angular.IOnChangesObject) {
        if (changes.hasOwnProperty('isDisabled')) {
            const isDisabled = changes['isDisabled'];
            if (isDisabled.currentValue) {
                this.selectedItem = null;
            } else if (isDisabled.previousValue) {
                this.selectItem();
            }
        }
        if(changes['groups']){
            this.selectItem();
        }
    }
}

export const wtGroupSelector: ComponentDefinition = {
    componentId: 'wtGroupSelector',
    controller: GroupSelectorController,
    template: require('./groupSelector.component.html'),
    controllerAs: 'vm',
    bindings: {
        formController: '=?',
        groups: '<',
        isDisabled: '<?',
        isRequired: '<?',
        model: '=',
        name: '@?',
        onChange: '&?',
        placement: '<?'
    }
};
